import React from 'react';

/**
 * answer_status 값에 따라 상태 뱃지 JSX를 반환합니다.
 * 'success' 또는 값이 없으면 null을 반환합니다.
 */
export const renderStatusBadge = (status) => {
    switch (status) {
        case 'success':
            return <span className="bg-green-50 text-green-600 border border-green-200 px-2 py-0.5 rounded-md text-[10px] font-bold">정상 응답</span>;
        case 'no_answer':
            return <span className="bg-gray-50 text-gray-500 border border-gray-200 px-2 py-0.5 rounded-md text-[10px] font-bold">미답변</span>;
        case 'error':
            return <span className="bg-red-50 text-red-500 border border-red-200 px-2 py-0.5 rounded-md text-[10px] font-bold">처리 오류</span>;
        case 'timeout':
            return <span className="bg-orange-50 text-orange-500 border border-orange-200 px-2 py-0.5 rounded-md text-[10px] font-bold">시간 초과</span>;
        case 'partial':
            return <span className="bg-blue-50 text-blue-500 border border-blue-200 px-2 py-0.5 rounded-md text-[10px] font-bold">부분 응답</span>;
        default:
            return null;
    }
};
